// extracted by mini-css-extract-plugin
module.exports = {"summaryStyle":"_3hnn9jNcg2o9uUHupcY3w5"};